export default __webpack_public_path__ + "static/Picture-Pick-8a775ac37a3a8a892c085422a1daf385.webp";